<div class="modal-backdrop" (click)="onBackdrop()" *ngIf="open">
  <div class="modal-dialog" (click)="$event.stopPropagation()">
    <button #firstFocusable class="modal-close" type="button" (click)="onCancel()">
      <mat-icon svgIcon="close" class="header-cross-icon"></mat-icon>
    </button>

    <h2 class="modal-title">{{ title }}</h2>
    <p class="modal-description" *ngIf="message as m">
      {{ m }}
    </p>

    <p class="modal-description" *ngIf="!message && sponsor">
      Switch to <strong>{{ sponsor }}</strong
      >?
    </p>
    <div class="modal-actions">
      <button class="btn btn-cancel" type="button" (click)="onCancel()">{{ cancelLabel }}</button>
      <button class="btn btn-accept" type="button" (click)="onConfirm()">{{ confirmLabel }}</button>
    </div>
  </div>
</div>
